import { render } from "./BaseCloseButton.vue?vue&type=template&id=2e5c8529&scoped=true"
import script from "./BaseCloseButton.vue?vue&type=script&lang=js"
export * from "./BaseCloseButton.vue?vue&type=script&lang=js"

import "./BaseCloseButton.vue?vue&type=style&index=0&id=2e5c8529&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5c8529"]])

export default __exports__